import { TalentsSavedSearch } from '../types';
import getHelper from '../../../services/getHelper';

export default getHelper<TalentsSavedSearch>('/talents-saved-searches/:id');
